import style from "./style/Error.module.css";
import pageStyle from "./style/Page.module.css";

function Error() {
    return (
        <div className={`${pageStyle.page} ${style.errcontainer}`}>
            <h1 className={style.err}>Error 404 - Page Not Found</h1>
        </div>
    )
}

export default Error;